import { render, staticRenderFns } from "./btn.component.vue?vue&type=template&id=93a30d96&scoped=true&lang=pug"
import script from "./btn.component.vue?vue&type=script&lang=ts"
export * from "./btn.component.vue?vue&type=script&lang=ts"
import style0 from "./btn.component.vue?vue&type=style&index=0&id=93a30d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a30d96",
  null
  
)

export default component.exports